module.exports = __webpack_public_path__ + "static/media/share_person6.b34c6c93.png";